import Column from '@components/column'

import Title from '@components/title'

import { Fragment } from 'react'

import PushNotificationForm from './form'
import NotificationList from './list'

const PushNotifications = () => {
  return (
    <Fragment>
      <Column>
        <Title textone="Push" texttwo="Notifications" />

        <PushNotificationForm />
        <NotificationList />
      </Column>
    </Fragment>
  )
}

export default PushNotifications
